import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream text-ink p-8 text-center">
          <div>
            <p className="font-serif text-2xl">Coś poszło nie tak.</p>
            <p className="mt-2 text-sm text-stone-500">
              Odśwież stronę, aby wrócić do Rezydencji REAL.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
